import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcBadMarkRed = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8.66663,
		cy: 8,
		r: 8,
		fill: "#FB5C5C"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.66699 8H12.667",
		stroke: "#F2F4F8",
		strokeWidth: 1.46457,
		strokeLinecap: "round"
	})]
});
export default SvgIcBadMarkRed;
